// Inspector invitation mail format — each company can save its own subject/message
// (Company.inviteMailTemplate, edited in CompanyForm.jsx); an empty field falls back
// to the defaults below. Placeholders like {vendorName} are filled from the enquiry
// in Manday.jsx before the coordinator sees the invite-preview modal.

export const INVITE_PLACEHOLDERS = [
  ['inspectorName',     'Inspector name'],
  ['vendorName',        'Vendor name'],
  ['location',          'Vendor address'],
  ['products',          'Equipment / products'],
  ['subjectDates',      'Dates (short, for subject)'],
  ['dates',             'Dates (long, for message)'],
  ['duration',          'Duration'],
  ['jobNumber',         'Job number'],
  ['clientRequirement', 'Client ref. / requirement'],
  ['companyName',       'Company name'],
];

export const DEFAULT_INVITE_SUBJECT =
  'Inspection Inquiry at {vendorName} – {location} – (Date {subjectDates}) – {jobNumber}';

export const DEFAULT_INVITE_MESSAGE = `Hello {inspectorName},
We have received the following inspection requirement and would like to check your availability and interest.

Vendor: {vendorName}
Location: {location}
Scope: TBD
Equipment: {products}
Date: {dates}
Duration: {duration}
Client Ref. / Requirement: {clientRequirement}


If you are interested and available for this assignment, kindly share your updated CV and all relevant certificates, along with your all-inclusive rate.

Note: This is an inquiry only. Final assignment is subject to client approval and formal confirmation from {companyName} Coordinator.`;

// Sample values for the live preview in CompanyForm.jsx.
export const SAMPLE_INVITE_VALUES = {
  inspectorName: 'John Smith',
  vendorName: 'ABC Engineering Pvt. Ltd.',
  location: 'Plot 12, GIDC, Vadodara, Gujarat',
  products: 'Pressure Vessel, Heat Exchanger',
  subjectDates: '21 Oct 2026 & 22 Oct 2026',
  dates: '21st October 2026 & 22nd October 2026',
  duration: '2 day(s)',
  jobNumber: 'A-1024',
  clientRequirement: 'Final inspection as per ITP',
};

// Replaces {key} with values[key]; unknown placeholders are left as typed so a
// typo stays visible in the preview instead of silently disappearing.
export const fillInviteTemplate = (template, values) =>
  String(template || '').replace(/\{(\w+)\}/g, (match, key) =>
    Object.prototype.hasOwnProperty.call(values, key) ? String(values[key] ?? '') : match);

export const resolveInviteTemplate = (company) => ({
  subject: company?.inviteMailTemplate?.subject?.trim() ? company.inviteMailTemplate.subject : DEFAULT_INVITE_SUBJECT,
  message: company?.inviteMailTemplate?.message?.trim() ? company.inviteMailTemplate.message : DEFAULT_INVITE_MESSAGE,
});
